<template>
  <div class="rodemap">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: 'cv-03',
          word:
            '这是天一门，进去就是一会儿要去的钦安殿了。钦安殿位于紫禁城中轴线北端，按古代阴阳五行学说，北方属水，所以它的院门名为“天一”，取自《易经》中“天一生水”之意。',
          audio: 'aj',
          scene: 'scene5',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/aj/04');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/天一门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
